import { createPortal } from "react-dom"
import styled from "styled-components"

import { ReactComponent as IconEye } from "assets/svg/icon-eye.svg"
import { ReactComponent as IconExternal } from "assets/svg/new-tab-open.svg"

import { ModalLayout } from "layouts/ModalLayout"
import { ModalHeader } from "components/common/ModalHeader"

const IconWrapper = styled.div`
  display: flex;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  border: 1px solid #e2e8f0;

  svg {
    width: 22px;
    height: 22px;
    path {
      stroke: #64748b;
    }
  }
`

const ContentWrapper = styled.div`
  max-height: 350px;
  overflow-y: auto;
  padding: 0 20px;
  margin-bottom: 20px;
`

const DeliveryItem = styled.div`
  padding: 16px 0;
  font-size: 16px;
  border-bottom: 1px solid #f1f5f9;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`

const DeliveryTitle = styled.div`
  line-height: 1.5;
  color: #0f172a;
  margin-bottom: 8px;
`

const TrackingNumberWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const TrackingNumberLabel = styled.span`
  line-height: 1.5;
  font-weight: 300;
  color: #64748b;
`

const TrackingNumberLink = styled.a`
  line-height: 1.5;
  color: #2db2c8;
  text-decoration: underline;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover {
    opacity: 0.8;
  }
`

const IconLinkWrapper = styled.span`
  text-decoration: none;
  display: inline-flex;
`

const ExternalIcon = styled(IconExternal)`
  width: 20px;
  height: 20px;
  flex-shrink: 0;

  path {
    stroke: #2db2c8;
  }
`

interface Props {
  onCancel: () => void
  trackingNumbers: number[]
}

export const TrackPackageModal = ({ onCancel, trackingNumbers }: Props) => {
  const totalDeliveries = trackingNumbers.length

  return (
    <>
      {createPortal(
        <ModalLayout width="450px" onClose={onCancel} isWithoutFooter>
          <ModalHeader title="Track Package">
            <IconWrapper>
              <IconEye />
            </IconWrapper>
          </ModalHeader>
          <ContentWrapper>
            {trackingNumbers.map((trackingNumber, index) => (
              <DeliveryItem key={index}>
                <DeliveryTitle>
                  Delivery {index + 1} of {totalDeliveries}
                </DeliveryTitle>
                <TrackingNumberWrapper>
                  <TrackingNumberLabel>Tracking number:</TrackingNumberLabel>
                  <TrackingNumberLink href={`https://parcelsapp.com/en/tracking/${trackingNumber}`} target="_blank">
                    {trackingNumber}
                    <IconLinkWrapper>
                      <ExternalIcon />
                    </IconLinkWrapper>
                  </TrackingNumberLink>
                </TrackingNumberWrapper>
              </DeliveryItem>
            ))}
          </ContentWrapper>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}
